import React from 'react';
import ReactDOM from 'react-dom/client';
import {createBrowserRouter, Navigate, RouterProvider} from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import SubscriptionPage from "./pages/Sub";
import ConnectPage from "./pages/Connect";
import HomePage from "./pages/Home";
import BuyPage from "./pages/Buy";
import PaymentCheckPage from "./pages/Payment-check";
import PrivacyPolicyPage from "./pages/PrivacyPolicy";

const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            {index: true, element: <HomePage/>},
            {path: '/sub', element: <SubscriptionPage />},
            {path: "/connect", element: <ConnectPage />},
            {path: "/buy", element: <BuyPage />},
            {path: "/payment-check", element: <PaymentCheckPage />},
            {path: "/docks/privacy-policy", element: <PrivacyPolicyPage />},
            {path: "/docks/public-", element: <PaymentCheckPage />},
            {path: "*", element: <Navigate to="/" replace={true} />},
        ]
    }
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
